import { initTimeFormat } from "./utils/time-format";
import { initShare } from "./utils/share";
import { initAbTest } from "./utils/ab-tests";
import { initCopyToClipboard } from "./utils/clipboard";
import { initSLider } from "./components/slider";
import { initHeaderNav } from "./layout/header-nav";
import { initCountryAndLanguage } from "./layout/footer/country-language";
import { initBadges } from "./pages/badges";
document.addEventListener("DOMContentLoaded", () => {
    const initializers = [
        //utils
        { name: 'TimeFormat', fn: initTimeFormat },
        { name: 'Share', fn: initShare },
        { name: 'AbTest', fn: initAbTest },
        { name: 'CopyToClipboard', fn: initCopyToClipboard },
        //Component
        { name: 'Slider', fn: initSLider },
        //Layout
        { name: 'HeaderNav', fn: initHeaderNav },
        { name: 'CountryAndLanguage', fn: initCountryAndLanguage },
        //Pages
        { name: 'Badges', fn: initBadges },
    ];
    initializers.forEach(({ name, fn }) => {
        try {
            fn();
        }
        catch (error) {
            console.error(`❌ ${name} failed:`, error);
        }
    });
});
